import React, { useEffect, useState, useCallback } from "react";
import "./nav.css";

const menuItems = [
  { hrefId: "#home", label: "Home" },
  { hrefId: "#about", label: "About" },
  { hrefId: "#skills", label: "Skills" },
  { hrefId: "#experience", label: "Experience" },
  { hrefId: "#portfolio", label: "Projects" },
  { hrefId: "#contact", label: "Contact" },
];

const Nav = () => {
  const [activeNav, setActiveNav] = useState("#home");
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const sectionIds = menuItems.map((i) => i.hrefId.replace("#", ""));
    const sections = sectionIds
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActiveNav(`#${e.target.id}`);
        });
      },
      { rootMargin: "-35% 0px -50% 0px", threshold: 0.1 }
    );
    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  const handleClick = useCallback((hrefId) => {
    setActiveNav(hrefId);
    setMenuOpen(false);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <nav
      className={`site-nav${scrolled ? " site-nav--scrolled" : ""}`}
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="container nav__inner">
        <a
          href="#home"
          className="nav__brand"
          onClick={() => handleClick("#home")}
        >
          {/* Pixel moon logo via CSS */}
          {/* <span className="nav__moon" aria-hidden="true" /> */}
          <span className="nav__brand-name">Kushtrim Shabani</span>
        </a>

        <div className="nav__links">
          {menuItems.map((item) => (
            <a
              onClick={() => handleClick(item.hrefId)}
              className={activeNav === item.hrefId ? "active" : ""}
              key={item.hrefId}
              href={item.hrefId}
            >
              {item.label}
            </a>
          ))}
        </div>

        <a href="#contact" className="btn btn-primary nav__cta">
          Say hello
        </a>

        <button
          className={`nav__hamburger${menuOpen ? " nav__hamburger--open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </div>

      {menuOpen && (
        <div className="nav__overlay" onClick={() => setMenuOpen(false)} />
      )}

      <div className={`nav__mobile${menuOpen ? " nav__mobile--open" : ""}`}>
        <div className="nav__mobile-links">
          {menuItems.map((item) => (
            <a
              onClick={() => handleClick(item.hrefId)}
              className={activeNav === item.hrefId ? "active" : ""}
              key={item.hrefId}
              href={item.hrefId}
            >
              {item.label}
            </a>
          ))}
        </div>
        <a
          href="#contact"
          className="btn btn-primary nav__mobile-cta"
          onClick={() => setMenuOpen(false)}
        >
          Say hello
        </a>
      </div>
    </nav>
  );
};

export default Nav;
